<section class="shopee-lazada-benefit-wrapper">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <div class="box__logo">
          <picture>
            <img
              src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section2/Lazada_Shopee_FlowAccount_Logo_v2.png"
              width="100%"
              height="auto"
              loading="lazy"
              alt="shopee_laz_logo_flowaccount"
              class="box__image-logo"
            />
          </picture>
        </div>
        <!-- deskop heading -->
        <h2 class="box__heading color-gray box__heading{{ translate.currentLang }}"
          >{{ 'SHOPEE_LAZADA.BENEFIT.HEADING' | translate }}
        </h2>

        <!-- list detail heading -->
        <div class="box__heading-detail-list">
          <div class="detail" [innerHTML]="'SHOPEE_LAZADA.BENEFIT.DETAIL' | translate"> </div>
          <div class="box__cover-mobile">
            <picture>
              <source
                srcset="
                  https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section2/Lazada_Shopee_FlowAccount_v5.webp
                "
                type="image/webp"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section2/Lazada_Shopee_FlowAccount_v5.png"
                width="100%"
                loading="lazy"
                alt="{{ getAltText }}"
                class="box__image"
              />
            </picture>
          </div>

          <ng-container *ngFor="let item of dataList">
            <p class="text-list"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span [innerHTML]="item.text | translate"></span
            ></p>
          </ng-container>
        </div>
      </div>

      <div class="box__right">
        <picture class="box__cover-desktop">
          <source
            srcset="
              https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section2/Lazada_Shopee_FlowAccount_v5.webp
            "
            type="image/webp"
          />
          <img
            src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section2/Lazada_Shopee_FlowAccount_v5.png"
            width="100%"
            loading="lazy"
            alt="{{ getAltText }}"
            class="box__image"
          />
        </picture>
      </div>
    </div>
  </div>
</section>
